import { render, staticRenderFns } from "./DietaryConfiguration.vue?vue&type=template&id=e266895e"
import script from "./DietaryConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./DietaryConfiguration.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports